import { render, staticRenderFns } from "./myelaside.vue?vue&type=template&id=10dd67b8&scoped=true&"
import script from "./myelaside.vue?vue&type=script&lang=js&"
export * from "./myelaside.vue?vue&type=script&lang=js&"
import style0 from "./myelaside.vue?vue&type=style&index=0&id=10dd67b8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10dd67b8",
  null
  
)

export default component.exports